import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M4 12h8", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M4 18V6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 18V6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M21 18h-4c0-4 4-3 4-6 0-1.5-2-2.5-4-1", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Heading2";
const Heading2 = memo(themed(Icon));
export {
  Heading2
};
//# sourceMappingURL=heading-2.js.map
